var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDrink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "-13.05 0 95.506 95.506",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.052,
    y1: 0.472,
    x2: 1.018,
    y2: 0.523,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9a973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e28b3d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.237,
    y1: 0.532,
    x2: 1.252,
    y2: 0.39,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feecd2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdac82"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drink_orange_juice",
    "data-name": "drink orange juice",
    transform: "translate(-1071.056 -801.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M1130.793,827.788a3.008,3.008,0,0,1-2.995,3h-53.747a3,3,0,0,1-2.995-3h0a3,3,0,0,1,2.995-3H1127.8a3.008,3.008,0,0,1,2.995,3Z",
    fill: "#a4d322"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M1076.294,830.785l8.615,65.917h32.024l8.615-65.917Z",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M1120.142,872.169l3.107-23.782H1078.6l3.106,23.782Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M1076.614,833.219h48.615l.319-2.434h-49.255Z",
    fill: "#c97027"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M1140.454,803.442a2.252,2.252,0,0,0-2.249-2.246,1.541,1.541,0,0,0-.279.06l-.01-.048c-.046.005-18.2,4.6-25.389,7.039-8.285,2.967-11.692,11.973-11.844,12.126l-.045.117-1.3,4.3h4.7l.858-2.821a22.279,22.279,0,0,1,2.314-3.96,14.657,14.657,0,0,1,6.768-5.507c6.793-2.313,24.449-6.76,24.465-6.765l.568-.211A2.232,2.232,0,0,0,1140.454,803.442Z",
    fill: "#27b7ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrink);
export default __webpack_public_path__ + "static/media/Drink.7ba8e701cf491a995dd46062ea3a4bf7.svg";
export { ForwardRef as ReactComponent };